import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axiosInstance from './../axiosInstance';
import Logbook from './Logbook';
import MyUserContext from './../myUserContext';

const LogbookPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const artId = queryParams.get('artId');
  const userId = queryParams.get('userId');
  const [artData, setArtData] = useState(null);
  const [logbookDateTimes, setLogbookDateTimes] = useState([]);
  const [loading, setLoading] = useState(true);
  const myUser = useContext(MyUserContext);
  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  useEffect(() => {
    if (artId) {
      axiosInstance
        .get(`/arts/${artId}/`)
        .then((response) => {
          setArtData(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
      
      const logbookUrl = userId 
        ? `/art/logbook/get?artId=${artId}&userId=${userId}` 
        : `/art/logbook/get?artId=${artId}`;
      
      axiosInstance
        .get(logbookUrl)
        .then((response) => {
          setLogbookDateTimes(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    }
  }, [artId, userId]);

  if (loading) {
    return <div></div>;
  }

  if (!artData) {
    return <div>Error loading art data.</div>;
  }

  return (
    <div className="logbook-page">
      <h2 className="text-center text-lg font-bold">
        {language === "ru" ? "Журнал" : "Logbook"}
      </h2>
      <div className="flex justify-center my-4">
        <Link to={`/arts/${artData.id}`}>
            <img
            className="object-cover rounded-lg max-w-[100px]"
            src={artData.thumbnailUrl}
            alt={artData.name || "Art Thumbnail"}
            />
        </Link>
      </div>
      <div className="flex justify-center">
        <Logbook
          initialDateTimes={logbookDateTimes}
          art={artData}
          language={language}
        />
      </div>
    </div>
  );
};

export default LogbookPage;
